module.exports = __webpack_public_path__ + "static/media/TenantBuyer4.0595e64e.jpg";